import { useSearchParams } from "react-router-dom";
import Layout from "@/components/Layout";
import DossiersList from "@/components/DossiersList";
import DossiersTabs from "@/components/DossiersTabs";
import { FolderOpen } from "@phosphor-icons/react";

/**
 * Page Dossiers — point d'entrée mobile vers le portefeuille.
 *
 * Tabs internes (3 sous-vues actives) :
 *  - "En montage"  → mandat NON signé
 *  - "À envoyer"   → mandat signé · pas encore envoyé
 *  - "En banque"   → envoyé / accord / offre / acte
 *
 * Tabs archives (navigation vers pages dédiées) :
 *  - "Signés"  → /signes
 *  - "Annulés" → /perdus
 *
 * URL : /dossiers?tab=montage|envoyer|banque (montage par défaut)
 */
const INTERNAL_TABS = {
  montage: { filter: "montage", emptyLabel: "Aucun dossier en montage.", subtitle: "Prospect / mandat non signé", label: "En montage" },
  envoyer: { filter: "envoyer", emptyLabel: "Aucun dossier à envoyer en banque.", subtitle: "Mandat signé · pas encore envoyé", label: "À envoyer" },
  banque: { filter: "banque", emptyLabel: "Aucun dossier en banque.", subtitle: "Envoyé / accord / offre / acte", label: "En banque" },
};

export default function Dossiers() {
  const [params, setParams] = useSearchParams();
  const tabParam = params.get("tab");
  const activeKey = INTERNAL_TABS[tabParam] ? tabParam : "montage";
  const active = INTERNAL_TABS[activeKey];

  const switchTab = (tab) => {
    if (tab.key === activeKey) return;
    const next = new URLSearchParams(params);
    next.set("tab", tab.key);
    setParams(next, { replace: true });
  };

  return (
    <Layout
      title="Dossiers"
      subtitle={
        <span className="flex items-center gap-1.5">
          <FolderOpen size={12} weight="fill" color="var(--cf-primary)" /> Portefeuille
        </span>
      }
    >
      <DossiersTabs activeKey={activeKey} onInternalSelect={switchTab} />

      <DossiersList
        key={activeKey}
        filterMode={active.filter}
        embedded
        title={active.label}
        subtitle={active.subtitle}
        emptyLabel={active.emptyLabel}
      />
    </Layout>
  );
}
